<script>
import fetcherCacheLoader from '@/mixins/fetcher/loaders/cache-loader';
import spawnerCacheLoader from '@/mixins/spawner/loaders/cache-loader';
// import crawlerCacheLoader from '@/mixins/crawler/loaders/cache-loader';
// import monitorCacheLoader from '@/mixins/monitor/loaders/cache-loader';

export default {
  mixins: [
    fetcherCacheLoader, //
    spawnerCacheLoader,
    // crawlerCacheLoader,
    // monitorCacheLoader,
  ],
  template: '<div></div>',
};
</script>
